import React from "react";

export default function Marquee({ children, className = "" }) {
  return (
    <div className={`overflow-hidden ${className}`} data-testid="marquee">
      <div className="marquee-track">
        <div className="flex items-center gap-16 pr-16">{children}</div>
        <div className="flex items-center gap-16 pr-16" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
}
